import {forwardRef, useMemo} from "react";
import * as MB from "../../../../mapbox";
import {useColorScheme} from "@mui/material/styles";
import {useTheme} from "@mui/material";

export interface MapboxOptions extends Omit<MB.MapboxOptions, 'theme' | 'container'> {

}

export interface MapboxProps extends Omit<MB.MapboxProps, 'options'> {
    options?: MapboxOptions;
}

const Mapbox = forwardRef<MB.MapboxRef, MB.MapboxProps>((props, ref) => {
    const {systemMode, mode} = useColorScheme();
    const theme = useTheme();

    const colorScheme = useMemo<MB.MapboxOptions['theme']>(() => (!mode || mode === 'system') ? systemMode ?? 'light' : mode, [systemMode, mode]);

    const options = useMemo<Required<MB.MapboxProps>['options']>(() => ({
        ...(props.options ?? {}),
        theme: colorScheme,
    }), [props.options, colorScheme])


    return (
        <MB.Mapbox
            {...props}
            options={options}
            ref={ref}
            flyToMarkerOnClick={props.flyToMarkerOnClick ?? true}
            markerColor={props.markerColor ?? theme.palette.primary.main}
        />
    );
});

export * from '../../../../mapbox';
export default Mapbox;
